import { createNavigationView } from './index'
import { VIEW_ADVERTISER } from '../constants'

const ProfileSidebar = () => import('../components/Profile/ProfileSidebar.vue')

const Adverts = () => import('../components/Adverts/Adverts.vue')
const EditAdvert = () => import('../components/Adverts/EditAdvert.vue')
const EditAdvertModal = () => import('../components/Adverts/EditAdvertModal.vue')
const AdvertDetailsModal = () => import('../components/Adverts/AdvertDetailsModal.vue')
const UpdateMinNettoWantedModal = () => import('../components/Adverts/UpdateMinNettoWantedModal.vue')
const DeactivateAdvertModal = () => import('../components/Adverts/DeactivateAdvertModal.vue')
const DeleteAdvertModal = () => import('../components/Adverts/DeleteAdvertModal.vue')
const ExpiredAdvertModal = () => import('../components/Adverts/ExpiredAdvertModal.vue')
const BidsModalAuthenticator = () => import('../components/BidSessions/BidsModalAuthenticator.vue')

export const routes = () => [
  {
    path: '/hirdeteseim/uj-hirdetes',
    components: {
      default: EditAdvert,
      navigation: createNavigationView('static'),
      sidebar: ProfileSidebar
    },
    meta: {
      pageTitle: 'Ads - New Ad',
      requiresAuth: true,
      requiresValidProfile: true,
      view: VIEW_ADVERTISER,
      wrapperClass: 'profile-wrapper'
    }
  },
  {
    path: '/hirdeteseim',
    components: {
      default: Adverts,
      navigation: createNavigationView('static'),
      sidebar: ProfileSidebar
    },
    children: [
      {
        path: 'ajanlat/:id/elozmeny',
        component: BidsModalAuthenticator,
        props: true,
        meta: {
          isModal: true,
          pageTitle: 'Ads - Bid History',
          requiresAuth: true,
          requiresValidProfile: true,
          view: VIEW_ADVERTISER,
          wrapperClass: 'profile-wrapper'
        }
      },
      {
        path: ':id/fizetesi-igeny-modositasa',
        component: UpdateMinNettoWantedModal,
        props: true,
        meta: {
          isModal: true,
          pageTitle: 'Ads - Change Min Netto Wanted',
          requiresAuth: true,
          requiresValidProfile: true,
          view: VIEW_ADVERTISER,
          wrapperClass: 'profile-wrapper'
        }
      },
      {
        path: ':id/modositas-megerositese',
        component: EditAdvertModal,
        props: true,
        meta: {
          isModal: true,
          pageTitle: 'Ads - Confirm Edit',
          requiresAuth: true,
          requiresValidProfile: true,
          view: VIEW_ADVERTISER,
          wrapperClass: 'profile-wrapper'
        }
      },
      {
        path: ':id/passzivalas',
        component: DeactivateAdvertModal,
        props: true,
        meta: {
          isModal: true,
          pageTitle: 'Ads - Deactivate',
          requiresAuth: true,
          requiresValidProfile: true,
          view: VIEW_ADVERTISER,
          wrapperClass: 'profile-wrapper'
        }
      },
      {
        path: ':id/torles',
        component: DeleteAdvertModal,
        props: true,
        meta: {
          isModal: true,
          pageTitle: 'Ads - Delete',
          requiresAuth: true,
          requiresValidProfile: true,
          view: VIEW_ADVERTISER,
          wrapperClass: 'profile-wrapper'
        }
      },
      {
        path: ':id/lejart-hirdetes',
        component: ExpiredAdvertModal,
        props: true,
        meta: {
          isModal: true,
          pageTitle: 'Ads - Delete',
          requiresAuth: true,
          requiresValidProfile: true,
          view: VIEW_ADVERTISER,
          wrapperClass: 'profile-wrapper'
        }
      },
      {
        path: ':id',
        component: AdvertDetailsModal,
        props: route => ({ id: route.params.id, size: 'large' }),
        meta: {
          isModal: true,
          pageTitle: 'Ads - Details',
          requiresAuth: true,
          requiresValidProfile: true,
          view: VIEW_ADVERTISER,
          wrapperClass: 'profile-wrapper'
        }
      }
    ],
    meta: {
      pageTitle: 'Ads',
      requiresAuth: true,
      requiresValidProfile: true,
      view: VIEW_ADVERTISER,
      wrapperClass: 'profile-wrapper'
    }
  },
  {
    path: '/hirdeteseim/:id/modositas',
    components: {
      default: EditAdvert,
      navigation: createNavigationView('static'),
      sidebar: ProfileSidebar
    },
    props: {
      default: true
    },
    meta: {
      pageTitle: 'Ads - Edit',
      requiresAuth: true,
      requiresValidProfile: true,
      view: VIEW_ADVERTISER,
      wrapperClass: 'profile-wrapper'
    }
  }
]



// WEBPACK FOOTER //
// ./src/router/adverts.js